<template>
    <div class="home-banner">
        <van-swipe v-if="bannerList.length" indicator-color="white" class="home-banner-swipe" @change="onChange">
            <van-swipe-item v-for="item in bannerList" :key="item.id" @click="handleNav2Detail(item)">
                <div class="banner-box">
                    <img :src="item.bannerWapUrl || item.bannerUrl" class="banner-img" />
                </div>
            </van-swipe-item>
            <template #indicator>
                <div class="indicator-wrapper">
                    <span
                        v-for="(item, index) in bannerList"
                        :key="index"
                        class="indicator-item"
                        :class="{'indicator-item__active': current == index}"
                    ></span>
                </div>
            </template>
        </van-swipe>
    </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant';
export default {
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
    },
    data() {
        return {
            bannerList: [],
            current: 0,
        };
    },

    computed: {
        user() {
            return this.$store.getters.userInfo;
        },
    },

    methods: {
        handleNav2Detail(item) {
            if (item.linkUrl.indexOf('/special/') > -1) {
                this.$router.push(`/special/${item.linkUrl.split('/special/')[1]}`);
            } else if (item.linkUrl.indexOf('/competitions/') > -1) {
                this.$router.push(`/competitions/${item.linkUrl.split('/competitions/')[1]}`);
            } else {
                location.href = item.linkUrl;
            }
        },
        onChange(index) {
            this.current = index;
        },
    },

    created() {
        this.$axios('getHomeBannerList').then(res => {
            this.bannerList = res.data;
        });
    },
};
</script>

<style lang="scss" scoped>
.home-banner {
    padding: 0px 14px 0 14px;
    .banner-box {
        width: 720px;
        height: 324px;
        border-radius: 28px;
        overflow: hidden;
        .banner-img {
            width: 720px;
            height: 324px;
        }
    }
    .home-banner-swipe {
        position: relative;
        .indicator-wrapper {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 20px;
            display: flex;
            text-align: center;
            .indicator-item {
                width: 12px;
                height: 12px;
                background: #ffffff;
                opacity: 0.5;
                border-radius: 50%;
                &:not(:last-child){
                    margin-right:20px;
                }
            }
            .indicator-item__active {
                opacity: 1;
            }
        }
    }
}
</style>
